import { isFunction } from 'lodash';

/**
 * Check if argument is thenable
 *
 * @param {any} promise
 */
export const isThenable = (promise) =>
    !!(promise && isFunction(promise.then) && isFunction(promise.catch));
